//var availableTags = [
//    "ActionScript",
//    "AppleScript",
//    "Asp",
//    "BASIC",
//    "C",
//    "C++",
//    "Clojure",
//    "COBOL",
//    "ColdFusion",
//    "Erlang",
//    "Fortran",
//    "Groovy",
//    "Haskell",
//    "Java",
//    "JavaScript",
//    "Lisp",
//    "Perl",
//    "PHP",
//    "Python",
//    "Ruby",
//    "Scala",
//    "Scheme"
//];
//function split(val) {
//    return val.split(/,\s*/);
//}
//function extractLast(term) {
//    return split(term).pop();
//}


//function createCustomDropdown(sourceData) {


//    return {
//        // Methods
//        closeEditor: function (cell, save) {
//            // Get value
//            console.log("closeEditor");

//            var txt = $(cell).find('.tt-input').val();
//            //  $(cell).find('.typeahead').typeahead("destroy");

//            console.log(txt);
//            // Set visual value
//            $(cell).html(txt);

//            // Close edition
//            $(cell).removeClass('edition');

//            // Save history
//            return txt;
//        },
//        openEditor: function (cell) {
//            // Get current content
//            var currentValue = $(cell).text();

//            var typeaheadName = "abc" + Math.floor(Math.random() * 110000);


//            //    currentValue = "";

//            // Create the editor
//           // var editor = document.createElement('input');

//            var editor = "<input type=\"text\" id=\"receiverDropdown\" name=\"receiverDropdown\" list=\"receiverDropdown-list\">";
//            editor += "<datalist id=\"receiverDropdown-list\">";

//            var sourceDataLength = sourceData.length;
//            for (var i = 0; i < sourceDataLength; i++) {
//                editor += "<option>" + sourceData[i] + "</option>";
//            }

//            editor += "</datalist>";

         
//           // $(editor).prop('class', 'typeahead');

//            $(cell).html(editor);
//            $(editor).prop('class', 'editor');
//            $(editor).val(currentValue);
//            $(editor).focus();
//            //$(editor).on('blur', function () {
//            //    $('#' + $.fn.jexcel.current).jexcel('closeEditor', $(cell), true);
//            //})
//            console.log("editor is");
//            console.log(editor);
//            // Create the instance of the plugin

//            $(document).on('change', "#receiverDropdown", function () {
//                var options = $('datalist')[0].options;
//                var val = $(this).val();
//                for (var i = 0; i < options.length; i++) {
//                    if (options[i].value === val) {
//                        setValue(cell, val);
//                        break;
//                    }
//                }
//            });

//        },
//        getValue: function (cell) {
//            console.log("fetching value");
//            return $(cell).text();
//        },
//        setValue: function (cell, value) {
//            console.log("setting value");
//            $(cell).html(value);

//            return true;
//        }
//    }

  

//}




////data = [
////    ['AppleScript,', 2001, 2000],
////    ['C,', 2009, 3000],
////    ['ActionScript,', 2010, 6000],
////];

////$('#my').jexcel({
////    data: data,
////    columns: [{ editor: customDropDown1 }, { type: 'text' }],
////    colHeaders: ['Model', 'Year', 'Price'],
////    colWidths: [300, 80, 100]
////});
